import { useEffect } from "react";

/** Same font stack as Financial Management / Material UI */
export const REPORT_FONT = '"Roboto", "Helvetica", "Arial", sans-serif';

/**
 * HTML table colors/sizes: see reportTableConfig.js
 * (TH_BG, CELL_FG, EVEN_BG/ODD_BG, etc.)
 */

/** Roboto is already loaded app-wide via public/index.html */
export const REPORT_FONT_URL = null;

const LINK_ID = "powerbi-report-font";

export function loadReportFonts() {
  // No-op: Roboto ships with the app shell. Kept for call-site compatibility.
  if (typeof document === "undefined") return;
  if (document.getElementById(LINK_ID)) return;
  // Remove legacy IBM Plex Sans stylesheet if a prior session injected it
  const legacy = document.getElementById("powerbi-ibm-plex-sans");
  if (legacy) legacy.remove();
  const marker = document.createElement("meta");
  marker.id = LINK_ID;
  marker.name = "powerbi-report-font";
  marker.content = "Roboto";
  document.head.appendChild(marker);
}

/** Safe to call from any report shell */
export function useReportFonts() {
  useEffect(() => {
    loadReportFonts();
  }, []);
}

loadReportFonts();
